export const SHORT_MESSAGE_TEMAPLTES_PREVIEW = {
  WHATSAPP_MESSAGE_CHANNEL_TAB_NAME: {
    key: 'WHATSAPP_MESSAGE_CHANNEL_TAB_NAME',
    value: 'Whatsapp',
  },
  VOICE_MESSAGE_CHANNEL_TAB_NAME: {
    key: 'VOICE_MESSAGE_CHANNEL_TAB_NAME',
    value: 'Voice message',
  },
  SMS_CHANNEL_TAB_NAME: {
    key: 'SMS_CHANNEL_TAB_NAME',
    value: 'SMS',
  },
  EMPTY_CHANNELS_INPUT_ERROR_MESSAGE: {
    key: 'EMPTY_CHANNELS_INPUT_ERROR_MESSAGE',
    value: 'All three channels are Empty!',
  },
  PREVIEW_TEMPLATE_TOOLTIP: {
    key: 'PREVIEW_TEMPLATE_TOOLTIP',
    value: 'Preview',
  },
};

export const SHORT_MESSAGE_TEMAPLTES_TAB = {
  LOADING_TEMPALTES: {
    key: 'LOADING_TEMPALTES',
    value: 'Loading...',
  },
  SEARCH_TEMPALTES_PLACEHOLDER: {
    key: 'SEARCH_TEMPALTES_PLACEHOLDER',
    value: 'Search Templates',
  },
  SEARCH_BY_CATEGORY_FILTER_POPUP_TITLE: {
    key: 'SEARCH_BY_CATEGORY_POPUP_TITLE',
    value: 'By Category',
  },
  SELECT_CATEGORY_FILTER_PLACEHOLDER: {
    key: 'SELECT_CATEGORY_FILTER_PLACEHOLDER',
    value: 'Select Category',
  },
  CLEAR_ALL_FILTERS_ACTION: {
    key: 'CLEAR_ALL_FILTERS_ACTION',
    value: 'Clear All',
  },
  SELECT_ALL_CATEGORY_DROPDOWN_OPTION: {
    key: 'SELECT_ALL_CATEGORY_DROPDOWN_OPTION',
    value: 'All',
  },
  APPLY_FILTERS_BUTTON: {
    key: 'APPLY_FILTERS_BUTTON',
    value: 'Apply Filters',
  },
  FILTERED_TEMPLATES_COUNT: {
    key: 'FILTERED_TEMPLATES_COUNT',
    value: 'We found {{templatesCount}} results based on your search ',
  },
  GOT_ALL_SEARCH_RESULTS: {
    key: 'GOT_ALL_SEARCH_RESULTS',
    value: 'You have got all search results',
  },
  NO_TEMPLATES_FOUND_RESULT_LABEL: {
    key: 'NO_TEMPLATES_FOUND_RESULT_LABEL',
    value: 'No templates available',
  },
  SEE_ALL_TEMPLATES_ACTION: {
    key: 'SEE_ALL_TEMPLATES_ACTION',
    value: 'See All',
  },
  EDIT_TEMPLATE_DROPDOWN_OPTION: {
    key: 'EDIT_TEMPLATE_DROPDOWN_OPTION',
    value: 'Edit',
  },
  DELETE_TEMPLATE_DROPDOWN_OPTION: {
    key: 'DELETE_TEMPLATE_DROPDOWN_OPTION',
    value: 'Delete',
  },
  MANAGE_TAGS_TEMPLATE_DROPDOWN_OPTION: {
    key: 'MANAGE_TAGS_TEMPLATE_DROPDOWN_OPTION',
    value: 'Manage Tags',
  },
  MY_DESIGN_TEMPLATES_TAB_LABEL: {
    key: 'MY_DESIGN_TEMPLATES_TAB_LABEL',
    value: 'My designs',
  },
  FILTERS_TITLE: {
    key: 'FILTERS_TITLE',
    value: 'Filters',
  },
  BY_LANGUAGE_LABEL: {
    key: 'BY_LANGUAGE_LABEL',
    value: 'By Language',
  },
};

export const SHORT_MESSAGE_TRANSLATE_TAB = {
  HIDE_SIDEBAR_TOOLTIP: {
    key: 'HIDE_SIDEBAR_TOOLTIP',
    value: 'Hide',
  },
  DELETE_TEMPLATE_LANGUAGE_BUTTON: { key: 'DELETE_TEMPLATE_LANGUAGE_BUTTON', value: 'Delete' },
  ADD_TEMPLATE_LANGUAGE_BUTTON: { key: 'ADD_TEMPLATE_LANGUAGE_BUTTON', value: 'Add' },
  TEMPLATE_AVAILABLE_IN_LANGUAGES: {
    key: 'TEMPLATE_AVAILABLE_IN_LANGUAGES',
    value: 'Template available in',
  },
  ALSO_AVAILABLE_LANGUAGES: { key: 'ALSO_AVAILABLE_LANGUAGES', value: 'Also available in' },
  TEMPLATES_LANG_NOT_AVAILABLE: {
    key: 'TEMPLATES_LANG_NOT_AVAILABLE',
    value: 'Sorry, language for the template is not detected / applicable',
  },
  COULD_NOT_TRANSLATE_TEMPLATE_ERROR_MESSAGE: {
    key: 'COULD_NOT_TRANSLATE_TEMPLATE_ERROR_MESSAGE',
    value: 'Could not translate template to {{name}} Please check limit for translation key.',
  },
  TEMPLATES_TRANSLATED_SUCCESS_MESSAGE: {
    key: 'TEMPLATES_TRANSLATED_SUCCESS_MESSAGE',
    value: 'Translated template to',
  },
  MESSAGE_STUDIO_LABEL: {
    key: 'MESSAGE_STUDIO_LABEL',
    value: 'MESSAGE STUDIO',
  }
};

export const COMMUNICATION_SETTINGS = {
  TEMPLATE_NAME_UNSUPPORTED_CHARS: {
    key: 'TEMPLATE_NAME_UNSUPPORTED_CHARS',
    value: 'The name contains unsupported characters: "{{char}}". Please use only letters, numbers, or these special characters: - _ ( ).'
  },
  TEMPLATE_NAME_UPDATE_FAILED_MESSAGE: {
    key: 'TEMPLATE_NAME_UPDATE_FAILED_MESSAGE',
    value:
      'Unable to update the name. Please try again!'
  },
  COMMUNICATION_NAME_ALREADY_EXISTS: {
    key: 'COMMUNICATION_NAME_ALREADY_EXISTS',
    value:
      'Communication name already exists'
  },
  TEMPLATE_NAME_EMPTY_WARNING: {
    key: 'TEMPLATE_NAME_EMPTY_WARNING',
    value:
      'Name cannot be empty'
  },
}
